<template>
  <div class="simple-notification">
    <div class="notification-head">
      <div class="notification-title">QRWaiter</div>
      <div class="notification-date">
        {{ notification.created_at | formatTime }}
      </div>
    </div>
    <div
      class="notification-body"
    >{{ notification.payload }}</div>
  </div>
</template>

<script>
export default {
  props: {
    notification: Object
  }
}
</script>

<style scoped>
.simple-notification {
  padding: 1.389vw;
  width: 23.264vw;
  background: #ffffff;
  box-shadow: 0px 0.278vw 0.278vw rgba(0, 0, 0, 0.25);
  border-radius: 0.833vw;
  margin-bottom: 1.389vw;
}
.notification-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.notification-title {
  font-weight: 500;
  font-size: 1.111vw;
  line-height: 1.25vw;
}
.notification-date {
  font-weight: 500;
  font-size: 0.972vw;
  line-height: 1.111vw;
  color: #a4a3a1;
}
.notification-body {
  font-weight: 500;
  font-size: 0.972vw;
  line-height: 1.111vw;
  color: #454543;
}
</style>